__turbopack_context__.v({
  "searchScope": "vP9eWq_searchScope",
});
